import { __rest } from "tslib";
export function mapByTargets(submission, form) {
    return mapBy(submission, form, 'target');
}
export function mapByIds(submission, form) {
    return mapBy(submission, form, 'id');
}
function mapBy(submission, form, by) {
    var _a;
    const from = by === 'id' ? 'target' : 'id';
    const fields = (_a = form === null || form === void 0 ? void 0 : form.fields) !== null && _a !== void 0 ? _a : [];
    return fields.reduce((acc, field) => {
        const source = field[from];
        const destination = field[by];
        if (source &&
            destination &&
            source !== destination &&
            acc.hasOwnProperty(source)) {
            acc[destination] = acc[source];
            const _a = acc, _b = source, omitted = _a[_b], rest = __rest(_a, [typeof _b === "symbol" ? _b : _b + ""]);
            acc = rest;
        }
        return acc;
    }, Object.assign({}, submission));
}
//# sourceMappingURL=submission-mapper.js.map